import { CallDetail } from "../types/call";
import { axiosWithHiHiAuth, axiosWithoutAuth } from "../utils/customAxios";

const hihiDeviceService = {
    getAuthenticationToken: async (temporaryToken: string): Promise<string> => {
        try {
            const response = await axiosWithoutAuth.post(`/HiHiDevice/ValidateToken`, {
                token: temporaryToken
            });
            return response.data.token;
        } catch (err) {
            throw err;
        }
    },

    getCallDetails: async (callHalfId?: string, callDateTime?: string): Promise<CallDetail> => {
        try {
            const response = await axiosWithHiHiAuth.get(`/CallDetail/HiHiDevice?callHalfId=${callHalfId}&callDateTime=${callDateTime}`);
            return response.data;
        } catch (err) {
            throw err;
        }
    },
}

export default hihiDeviceService;